import React from "react";

export type typeNotFoundPageComponent = {
  title: React.ReactNode;
  message: React.ReactNode;
};

export const ViewComponent: React.FC<typeNotFoundPageComponent> = ({
  title,
  message,
}) => {
  return (
    <div className="absolute inset-0 flex flex-col justify-center place-self-center not-found-page">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white border py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <h2 className="text-center text-3xl font-extrabold text-gray-900">
            {title}
          </h2>
          <p className="mt-8 text-center text-sm text-gray-600">{message}</p>
        </div>
      </div>
    </div>
  );
};
